import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCall = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <g clipPath="url(#clip0_934_6824)">
          <path d="M21.9991 7.68C21.8745 7.60299 21.7322 7.55692 21.5847 7.5459C21.4372 7.53488 21.2892 7.55925 21.1539 7.61684L17.5244 9.17473V8.14316C17.5244 7.57476 17.2907 7.02964 16.8748 6.62772C16.4589 6.2258 15.8948 6 15.3066 6H4.21777C3.62958 6 3.06548 6.2258 2.64957 6.62772C2.23366 7.02964 2 7.57476 2 8.14316V15.8568C2 16.4252 2.23366 16.9704 2.64957 17.3723C3.06548 17.7742 3.62958 18 4.21777 18H15.3066C15.8948 18 16.4589 17.7742 16.8748 17.3723C17.2907 16.9704 17.5244 16.4252 17.5244 15.8568V14.8253L21.1539 16.3832C21.2679 16.4316 21.3909 16.4574 21.5155 16.4589C21.687 16.4576 21.8547 16.4094 21.9991 16.32C22.1237 16.2428 22.2259 16.1361 22.2961 16.0102C22.3662 15.8842 22.402 15.743 22.4 15.6V8.4C22.402 8.25697 22.3662 8.11581 22.2961 7.98984C22.2259 7.86386 22.1237 7.75723 21.9991 7.68ZM15.7467 15.8568C15.7467 15.9685 15.7008 16.0756 15.6191 16.1546C15.5374 16.2335 15.4265 16.2779 15.311 16.2779H4.21777C4.10221 16.2779 3.99139 16.2335 3.90967 16.1546C3.82796 16.0756 3.78206 15.9685 3.78206 15.8568V8.14316C3.78206 8.03149 3.82796 7.92439 3.90967 7.84543C3.99139 7.76646 4.10221 7.7221 4.21777 7.7221H15.3066C15.4222 7.7221 15.533 7.76646 15.6147 7.84543C15.6964 7.92439 15.7423 8.03149 15.7423 8.14316L15.7467 15.8568ZM20.6267 14.2821L17.6115 12.9937V11.0147L20.6267 9.75158V14.2821ZM9.53781 9.85684C9.53781 10.0802 9.446 10.2944 9.28257 10.4523C9.11915 10.6102 8.8975 10.6989 8.66638 10.6989H6.44862C6.21288 10.6989 5.98679 10.6085 5.8201 10.4474C5.65341 10.2863 5.55976 10.0678 5.55976 9.84C5.55976 9.61219 5.65341 9.39372 5.8201 9.23263C5.98679 9.07155 6.21288 8.98105 6.44862 8.98105H8.6446C8.87571 8.98105 9.09736 9.06977 9.26079 9.2277C9.42421 9.38563 9.51602 9.59982 9.51602 9.82316L9.53781 9.85684Z" />
        </g>
        <defs>
          <clipPath id="clip0_934_6824">
            <rect width="20.4" height="12" fill="currentColor" transform="translate(2 6)" />
          </clipPath>
        </defs>
      </svg>
    );
  }
);
